// extracted by mini-css-extract-plugin
export default {"payment-detail-container":"PaymentDetailsGrid_payment-detail-container__zZ968","item-container":"PaymentDetailsGrid_item-container__xGTxi"};